"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectIconStyled = void 0;
const design_system_1 = require("@produits-internes-oss/design-system");
exports.SelectIconStyled = styled.div `
&.octo {
  display: flex;
  flex-flow: column nowrap;
  gap: 0.25em;
  align-items: stretch;
  justify-content: stretch;

  >.title {
    font-weight: 600;
  }

  >.icons {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;

    > button {
      cursor: pointer;

      span {
        width: 1em;
        height: 1em;
      }

      &:hover {
        color: ${design_system_1.theme.colors.turquoise[100]};
      }

      &:disabled {
        cursor: default;

        &:hover {
          color: currentcolor;
        }
      }
    }
  }
}
`;
//# sourceMappingURL=SelectIcon.styled.js.map